function e(e, t) {
  return null != t && e instanceof t;
}

function t(r, o, i, c, f) {
  "object" == typeof o && (i = o.depth, c = o.prototype, f = o.includeNonEnumerable, o = o.circular);
  var u = [],
      a = [];
  return void 0 === o && (o = !0), void 0 === i && (i = 1 / 0), function r(i, l) {
    if (null === i) return null;
    if (0 === l) return i;
    var p, s;
    if ("object" != typeof i) return i;
    if (e(i, Map)) p = new Map();else if (e(i, Set)) p = new Set();else if (e(i, Promise)) p = new Promise(function (e, t) {
      i.then(function (t) {
        e(r(t, l - 1));
      }, function (e) {
        t(r(e, l - 1));
      });
    });else if (t.__isArray(i)) p = [];else if (t.__isRegExp(i)) p = new RegExp(i.source, n(i)), i.lastIndex && (p.lastIndex = i.lastIndex);else if (t.__isDate(i)) p = new Date(i.getTime());else if (e(i, Error)) p = Object.create(i);else if (void 0 === c) {
      if (e(s = Object.getPrototypeOf(i), Object)) return i;
      p = Object.create(s);
    } else p = Object.create(c), s = c;

    if (o) {
      var b = u.indexOf(i);
      if (-1 != b) return a[b];
      u.push(i), a.push(p);
    }

    for (var y in e(i, Map) && i.forEach(function (e, t) {
      var n = r(t, l - 1),
          o = r(e, l - 1);
      p.set(n, o);
    }), e(i, Set) && i.forEach(function (e) {
      var t = r(e, l - 1);
      p.add(t);
    }), i) {
      Object.getOwnPropertyDescriptor(i, y) && (p[y] = r(i[y], l - 1));

      try {
        if (void 0 === Object.getOwnPropertyDescriptor(i, y).set) continue;
        p[y] = r(i[y], l - 1);
      } catch (e) {
        if (e instanceof TypeError) continue;
        if (e instanceof ReferenceError) continue;
      }
    }

    if (Object.getOwnPropertySymbols) {
      var j = Object.getOwnPropertySymbols(i);

      for (y = 0; y < j.length; y++) {
        var O = j[y];
        (!(v = Object.getOwnPropertyDescriptor(i, O)) || v.enumerable || f) && (p[O] = r(i[O], l - 1), Object.defineProperty(p, O, v));
      }
    }

    if (f) {
      var g = Object.getOwnPropertyNames(i);

      for (y = 0; y < g.length; y++) {
        var v,
            _ = g[y];
        (v = Object.getOwnPropertyDescriptor(i, _)) && v.enumerable || (p[_] = r(i[_], l - 1), Object.defineProperty(p, _, v));
      }
    }

    return p;
  }(r, i);
}

function r(e) {
  return Object.prototype.toString.call(e);
}

function n(e) {
  var t = "";
  return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), t;
}

t.clonePrototype = function (e) {
  if (null === e) return null;

  var t = function t() {};

  return t.prototype = e, new t();
}, t.__objToStr = r, t.__isDate = function (e) {
  return "object" == typeof e && "[object Date]" === r(e);
}, t.__isArray = function (e) {
  return "object" == typeof e && "[object Array]" === r(e);
}, t.__isRegExp = function (e) {
  return "object" == typeof e && "[object RegExp]" === r(e);
}, t.__getRegExpFlags = n;
export default t;